import React, { Component, createContext } from 'react';
import authService from '../services/authService';

export const AuthContext = createContext();

export class AuthProvider extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      user: null,
      loading: true,
      // ✅ Removed error from here - components handle their own errors
    };
  }

  componentDidMount() {
    this.initializeAuth();
  }

  initializeAuth = async () => {
    const result = await authService.getCurrentUser();
    
    if (result.success) {
      this.setState({ user: result.user, loading: false });
    } else {
      this.setState({ loading: false });
    }
  };

  login = async (email, password) => {
    // ✅ Don't set any error state here - just return the result
    const result = await authService.login(email, password);
    
    if (result.success) {
      this.setState({ user: result.user });
      return { success: true };
    } else {
      return { success: false, error: result.error };
    }
  };

  logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.setState({ user: null, isAuthenticated: false });
    
    // ✅ Reset notifications on logout
    // We'll call this via a ref in App.js
    
    window.location.href = '/login';
  };

  render() {
    const { user, loading } = this.state;
    
    const value = {
      user,
      loading,
      // ✅ No error in context
      login: this.login,
      logout: this.logout,
      isAuthenticated: !!user,
    };

    return (
      <AuthContext.Provider value={value}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};